import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-review-index-route.tsx
var LazyReviewIndexRoute = lazy(() => import("./review-index-route-BqN53ikT.js").then((n) => n.n).then((module) => ({ default: module.ReviewIndexRoute })));
function ReviewIndexRoute({ route, ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "review-index-route" }),
		children: /* @__PURE__ */ jsx(LazyReviewIndexRoute, {
			route,
			...props
		})
	});
}
var useReviewIndexRoute = () => {
	return useMemo(() => ({ "review-index-route": { component: ReviewIndexRoute } }), []);
};
//#endregion
export { useReviewIndexRoute };
